import React from 'react';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Slide from '@material-ui/core/Slide';
import {
  BACKGROUND_BLACK,
} from '../styles/Colors';
import BrandComponent from './BrandComponent';
import NavMenuComponent from './NavMenuComponent';

const styles = {
  rowContainer: {
    backgroundColor: BACKGROUND_BLACK,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    padding: '0 8px',
  },
};

const Header = () => {
  const trigger = useScrollTrigger();
  return (
    <Slide
      appear={false}
      direction="down"
      in={!trigger}
    >
      <div style={styles.rowContainer}>
        <BrandComponent />
        <NavMenuComponent />
      </div>
    </Slide>
  );
};

Header.propTypes = {};

Header.defaultProps = {};

export default Header;
